<template>
    <component :is="tagName" :disabled="itemDisabled" :class="classes"  @click="handleClickLink" >
         <i class="yjui-load-loop icon-shuaxin_1"  v-if="loading"></i>
         <i :class="icon"  v-if="icon"></i>
        <span v-if="showSlot" ref="slot"><slot></slot></span>
    </component>
</template>
<script>
  import mixinsForm from '../../mixins/form';
    const prefixCls = 'yjui-btn';
    export default {
        name: 'Button',
         mixins: [ mixinsForm ],
        props: {
            type: {//按钮类型
                  type: String,
                  default: 'default'
            },
            shape: {//圆角
                type: String,
                default: ''
            },
            size: {//按钮大小
                  type: String,
                  default: 'default'
        
            },
            loading: Boolean,
            disabled: Boolean,
            icon: {
                type: String,
                default: ''
            }
        },
        computed: {
            showSlot () {
                return !!this.$slots.default;
            },
            classes () {
                return [
                    `${prefixCls}`,
                    `${prefixCls}-${this.type}`,
                    {
                        [`${prefixCls}-${this.shape}`]: !!this.shape,
                        [`${prefixCls}-${this.size}`]: this.size !== 'default',
                        [`${prefixCls}-loading`]: this.loading != null && this.loading,

                    }
                ];
            },
        tagName() {
                const {isHrefPattern} = this;
                return isHrefPattern ? 'a' : 'button';
            },
        },
        methods: {
            // Ctrl or CMD and click, open in new window when use `to`
            handleClickLink (event) {
                this.$emit('click', event);
                //const openInNewWindow = event.ctrlKey || event.metaKey;

               // this.handleCheckClick(event, openInNewWindow);
            }
        }
    };
</script>

<style scoped>


.yjui-load-loop {
    -webkit-animation: ani-load-loop 1s linear infinite;
    animation: ani-load-loop 1s linear infinite;
      
}
@-webkit-keyframes ani-load-loop{
  0%{
    -webkit-transform:rotate(0);transform:rotate(0)
  }
  50%
  {
    -webkit-transform:rotate(180deg);transform:rotate(180deg)
  }to
  {
    -webkit-transform:rotate(1turn);transform:rotate(1turn)
  }
  }
    @keyframes ani-load-loop{
      0%{-webkit-transform:rotate(0);transform:rotate(0)}
      50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}



</style>




// WEBPACK FOOTER //
// src/components/button/button.vue